<strong>{{'TWO_FACTOR_AUTHENTICATION' |translate}}</strong>
<div class="mt-3">
  <!--Container if 2FA is not yet enabled for customer-->
  @if (customer && !customer.twoFactorAuthEnabled) {
    <div>
      <p>
        {{'TWO_FACTOR_DISABLED_INFORMATION' |translate}}
      </p>
      <p>
        <button class="btn btn-primary" (click)="enableTwoFactorAuthentication()">{{'ENABLE_TWO_FACTOR_AUTHENTICATION' |translate}}</button>
      </p>
    </div>
  }
  <!--Container if 2FA is enabled for customer-->
  @if (customer && customer.twoFactorAuthEnabled) {
    <div>
      <div>
        {{'TWO_FACTOR_ENABLED_INFORMATION' |translate}}
      </div>
      <div class="mt-2">
        <button class="btn btn-primary" (click)="showTwoFactorAuthDetails()">{{!twoFactorAuthDetails ? ('SHOW_TWO_FACTOR_AUTHENTICATION_DETAILS' |translate) : ('HIDE_TWO_FACTOR_AUTHENTICATION_DETAILS' |translate)}}</button>
        @if (twoFactorAuthDetails) {
          <div class="mt-4">
            <p>
              1. {{'TWO_FACTOR_INFO_STEP1' |translate}}
            </p>
            <p>
              2. {{'TWO_FACTOR_INFO_STEP2' |translate}}
            </p>
            <p>
              <img [src]="twoFactorAuthDetails.qrCode" /><br>{{'MANUAL_CODE' |translate}}: {{twoFactorAuthDetails.manualCode}}
            </p>
            <hr>
              @if (user.roleLevel === 200) {
                <div>
                  @if (!twoFactorDisableConfirm) {
                    <div>
                      <button class="btn btn-danger" (click)="twoFactorDisableConfirm = true">{{'DISABLE_TWO_FACTOR_AUTHENTICATION' |translate}}</button>
                    </div>
                  }
                  @if (twoFactorDisableConfirm) {
                    <div>
                      <p>
                        <strong>{{'DISABLE_TWO_FACTOR_AUTHENTICATION_CONFIRM_INFO' |translate}}</strong>
                      </p>
                      <p>
                        {{'DISABLE_TWO_FACTOR_AUTHENTICATION_CONFIRM' |translate}}
                      </p>
                      <button class="btn btn-danger" (click)="disableTwoFactorAuthentication()">{{'DELETE' |translate}}</button>
                      <button class="btn btn-outline-primary ml-3" (click)="twoFactorDisableConfirm = false">{{'CANCEL' |translate}}</button>
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
  </div>